import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
  notFoundComponent: () => (
    <main className="ca-page" data-testid="notfound-page" style={{ padding: 'var(--space-8)' }}>
      <h1 className="ca-h2">Página não encontrada</h1>
      <p className="ca-muted">O endereço que você acessou não existe.</p>
    </main>
  ),
});
